import React, { useState } from 'react';
import styled from '@emotion/styled';

import Container from './Container';
import Hamburger from './Hamburger';

import vw from 'styles/utils';
import media from 'styles/media';

function Header() {
  const [isHamburgerActive, setIsHamburgerActive] = useState(false);

  const handleClickHamburger = () => {
    setIsHamburgerActive(!isHamburgerActive);
  }

  return (
    <Root>
      <StyledContainer>
        <a href="/">
          <Logo src={require('assets/images/logo.png')} alt="IEK logo" />
        </a>
        <LinksWrapper>
          <a href='https://ieknet.iek.org.tw/' target='_blank' rel="noreferrer">首頁</a>
          <a href='https://ieknet.iek.org.tw/book/Default.aspx' target='_blank' rel="noreferrer">線上購</a>
          <a href='https://ieknet.iek.org.tw/contact/' target='_blank' rel="noreferrer">
            <Button>
              專案洽詢
            </Button>
          </a>
        </LinksWrapper>
        <Hamburger active={isHamburgerActive} onClick={handleClickHamburger} />
      </StyledContainer>
      <MobileNav show={isHamburgerActive}>
        <a href='https://ieknet.iek.org.tw/' target='_blank' rel="noreferrer">首頁</a>
        <a href='https://ieknet.iek.org.tw/book/Default.aspx' target='_blank' rel="noreferrer">線上購</a>
        <a href='https://ieknet.iek.org.tw/contact/' target='_blank' rel="noreferrer">專案洽詢</a>
      </MobileNav>
    </Root>
  )
}

Header.propTypes = {}

const Root = styled.header`
  background: white;

  ${vw('padding-top', 10, 20)}
  ${vw('padding-bottom', 10, 20)}
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.img`
  ${vw('width', 150, 188, 188)}
  ${vw('height', 30, 40, 40)}
`;

const LinksWrapper = styled.div`
  display: none;

  > a {
    color: #252525;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;

    ${vw('font-size', 16)}
    ${vw('line-height', 32)}
  }

  @media ${media.tablet} {
    display: grid;
    grid-template-columns: auto auto auto;
    align-items: center;
  }

  ${vw('grid-gap', 30)}
`;

const Button = styled.button`
  color: white;
  background: #3398DC;
  border: none;
  cursor: pointer;
  transition: all 0.25s;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;

  ${vw('font-size', 16)}
  ${vw('line-height', 32)}
  ${vw('width', 124)}
  ${vw('height', 38)}
  ${vw('border-radius', 30)}

  &:hover{
    background: #26304D;
  }
`;

const MobileNav = styled.nav`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: #3398DC;
  transition: all 0.25s;
  opacity: ${props => props.show ? '1' : '0'};
  pointer-events: ${props => props.show ? 'auto' : 'none'};

  > a {
    color: white;

    ${vw('padding', 4)}
  }
`;

export default Header
